export default __webpack_public_path__ + "static/media/cupcakes.937bc1b3.webp";